module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image28.a82313ce.webp";